// extracted by mini-css-extract-plugin
export default {"Box":"AuthorLink-module__Box--BC14X","Link":"AuthorLink-module__Link--Uj9H4"};